import { LOGIN_REDIRECT_KEY } from 'constants/app';

export default function saveLoginRedirect() {
  const {
    location: { pathname, search },
  } = window;
  localStorage.setItem(LOGIN_REDIRECT_KEY, pathname + search);
}
